/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Step5Inputs */

const en_dr_room_step5 = /** @type {(inputs: Dr_Room_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose`)
};

const id_dr_room_step5 = /** @type {(inputs: Dr_Room_Step5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih`)
};

/**
* | output |
* | --- |
* | "Choose" |
*
* @param {Dr_Room_Step5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_step5 = /** @type {((inputs?: Dr_Room_Step5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Step5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_step5(inputs)
	return en_dr_room_step5(inputs)
});